import { useDispatch } from 'react-redux'

export const alertActions = {
	success,
	error,
	clear,
	successEnqueueSnackbar,
	errorEnqueueSnackbar,
	warningEnqueueSnackbar,
	enqueueSnackbar,
	closeSnackbar,
	removeSnackbar
}

export const ALERT_SUCCESS = 'ALERT_SUCCESS'
export const ALERT_ERROR = 'ALERT_ERROR'
export const ALERT_CLEAR = 'ALERT_CLEAR'
export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR'
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR'
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR'

function success(message) {
	return { type: ALERT_SUCCESS, message }
}

function error(message) {
	return { type: ALERT_ERROR, message }
}

function clear() {
	return { type: ALERT_CLEAR }
}

function createError(message) {
	return {
		message: message,
		options: {
			key: new Date().getTime() + Math.random(),
			variant: 'error'
		}
	}
}

function createSuccess(message) {
	return {
		message: message,
		options: {
			key: new Date().getTime() + Math.random(),
			variant: 'success'
		}
	}
}

function createWarning(message) {
	return {
		message: message,
		options: {
			key: new Date().getTime() + Math.random(),
			variant: 'warning'
		}
	}
}

function successEnqueueSnackbar(message) {
	return enqueueSnackbar(createSuccess(message))
}

function errorEnqueueSnackbar(message) {
	return enqueueSnackbar(createError(message))
}

function warningEnqueueSnackbar(message) {
	return enqueueSnackbar(createWarning(message))
}

function enqueueSnackbar(notification) {
	const key = notification.options && notification.options.key

	return {
		type: ENQUEUE_SNACKBAR,
		notification: {
			...notification,
			key: key || new Date().getTime() + Math.random()
		}
	}
}

function closeSnackbar(key) {
	return {
		type: CLOSE_SNACKBAR,
		dismissAll: !key, // dismiss all if no key has been defined
		key
	}
}

function removeSnackbar(key) {
	return {
		type: REMOVE_SNACKBAR,
		key
	}
}

export const useAlertSnackbar = () => {
	const dispatch = useDispatch()

	return {
		success: (message) => dispatch(successEnqueueSnackbar(message)),
		error: (message) => dispatch(errorEnqueueSnackbar(message))
	}
}
